const APISERVER = "https://n-task-json-server-react.herokuapp.com";

export default APISERVER;
